<template lang="html">
  <div class="sign-in-change-password-view view">
    <router-link class="back-button" :to="{ name: signInRouteName }">
      <v-icon>arrow_back</v-icon>{{ $t('back') }}
    </router-link>

    <h1>{{ $t('changePassword.title') }}</h1>
    <div class="error-message">
      {{ errorMessage }}
    </div>

    <change-password-form :submited="submited" @submit="submit" />
    <!-- <login-form :submited="submited" @submit="login" /> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { challengeChangePassword, getSignInNextStepRoute } from '@/amplify/auth';
import { authChallenges } from '@/amplify/constants';
import { authErrors } from '@/amplify/errors';
import { DEFAULT_LOGGED_IN_ROUTE, views } from '@/router/constants';

import ChangePasswordForm from '@/components/forms/ChangePasswordForm.vue';

export default {
  name: 'SignInChangePassword',
  components: {
    ChangePasswordForm,
  },
  data() {
    return {
      errorMessage: '',
      submited: false,
    };
  },
  computed: {
    ...mapGetters(['authChallenge']),
    signInRouteName: () => views.SIGN_IN,
  },
  async mounted() {
    if (
      !this.authChallenge ||
      !this.authChallenge.challengeUser ||
      this.authChallenge.challengeName !== authChallenges.NEW_PASSWORD_REQUIRED
    ) {
      await this.$router.push({ name: views.SIGN_IN });
    }
  },
  methods: {
    async submit({ password }) {
      this.submited = true;

      try {
        await challengeChangePassword(password);
        await this.$router.push({ name: DEFAULT_LOGGED_IN_ROUTE });
        this.submited = false;
      } catch (e) {
        const { code, message } = e || {};

        if (code === authErrors.NOT_AUTHORIZED) {
          this.errorMessage = message;
        } else if (code === authErrors.INVALID_PASSWORD) {
          // Unfortunately the only way to understand reason of incorrect password is in message. So to provide exact
          // reason of error we have to show Cognito error message.
          // TODO: should be refactored in case of adding non English translations
          this.errorMessage = message.replace('Password does not conform to policy:', '').trim();
        } else if (code === authErrors.CHALLENGE_REQUIRED) {
          const nextRouteName = getSignInNextStepRoute();

          if (nextRouteName) {
            await this.$router.push({ name: nextRouteName });
          } else {
            this.errorMessage = this.$t('error.general');
          }
        } else {
          this.errorMessage = this.$t('error.general');
        }
      }

      this.submited = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.sign-in-change-password-view {
  max-width: rem(300);
  padding-top: rem(130);
  position: relative;
  margin-left: rem(180);
}

.back-button {
  position: absolute;
  top: $space-5;
  left: rem(-100);
  font-size: $font-size-sm;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  align-items: center;

  .v-icon {
    color: $auth-brand;
    margin-right: $space-2;
  }
}

h1 {
  text-align: center;
  margin-bottom: $space-7;
}

.error-message {
  color: $auth-error;
  font-size: $font-size-sm;
  line-height: $font-size-base;
  min-height: $font-size-base;
  margin-bottom: $space-2;
  text-align: center;
}
</style>
